// assets
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';

// icons
const icons = {
  AppstoreOutlined
};

// ==============================|| MENU ITEMS - CROPS (PLACEHOLDER) ||============================== //
// Shown instead of (or alongside) Livestock Batches for a CROPS/BOTH-focused
// organization - crop-ops has no real feature yet (docs/product/08-farm-manager-gaps.md
// section B), so this discloses that plainly rather than a silent empty menu.

const crops = {
  id: 'group-crops',
  title: 'Farm',
  type: 'group',
  children: [
    {
      id: 'crops',
      title: 'Crop Tracking',
      type: 'item',
      url: '#',
      icon: icons.AppstoreOutlined,
      breadcrumbs: false,
      disabled: true,
      chip: { label: 'Coming soon', color: 'secondary', variant: 'outlined', size: 'small' }
    }
  ]
};

export default crops;
